import React from "react";
import { Download, X, Share, Plus } from "lucide-react";
import { useInstall } from "../lib/install.jsx";

export function InstallButton({ variant = "header" }) {
  const { canInstall, installed, triggerInstall } = useInstall();
  if (installed || !canInstall) return null;

  if (variant === "ghost") {
    return (
      <button onClick={triggerInstall} className="brimi-btn-ghost" data-testid="install-app-btn">
        <Download size={16} /> Install app
      </button>
    );
  }
  // header variant — compact
  return (
    <button
      onClick={triggerInstall}
      className="hidden sm:inline-flex items-center gap-1.5 rounded-xl px-3 py-2 text-sm font-medium text-brimi-navy hover:bg-brimi-creamSoft transition"
      data-testid="install-app-btn"
      title="Install BrimiH&G as an app"
    >
      <Download size={15} /> Install
    </button>
  );
}

export function IOSInstallModal() {
  const { showIOSGuide, dismissIOSGuide } = useInstall();
  if (!showIOSGuide) return null;
  return (
    <div
      className="fixed inset-0 z-50 bg-brimi-navyText/40 backdrop-blur-sm grid place-items-center px-4"
      onClick={dismissIOSGuide}
      data-testid="ios-install-modal"
    >
      <div
        className="brimi-card max-w-sm w-full p-6 stagger-in relative"
        onClick={(e) => e.stopPropagation()}
      >
        <button
          onClick={dismissIOSGuide}
          className="absolute top-3 right-3 p-1 rounded-lg hover:bg-brimi-creamSoft text-brimi-navyText/60"
          data-testid="ios-modal-close"
          aria-label="Close"
        >
          <X size={18} />
        </button>
        <div className="w-12 h-12 grid place-items-center bg-brimi-navy/10 text-brimi-navy rounded-2xl">
          <Download size={22} />
        </div>
        <h2 className="font-heading font-semibold text-xl text-brimi-navyText mt-4">
          Install BrimiH&amp;G on iPhone
        </h2>
        <p className="text-sm text-brimi-navyText/70 mt-1">
          Add the app to your Home Screen in 3 quick steps:
        </p>
        <ol className="mt-4 space-y-3 text-sm text-brimi-navyText/85">
          <li className="flex items-start gap-3">
            <span className="w-6 h-6 grid place-items-center rounded-full bg-brimi-navy text-white text-xs font-bold flex-shrink-0 mt-0.5">
              1
            </span>
            <span className="flex items-center gap-1.5 flex-wrap">
              Tap the <Share size={16} className="text-brimi-navy inline" /> <strong>Share</strong> icon at the bottom of Safari.
            </span>
          </li>
          <li className="flex items-start gap-3">
            <span className="w-6 h-6 grid place-items-center rounded-full bg-brimi-navy text-white text-xs font-bold flex-shrink-0 mt-0.5">
              2
            </span>
            <span className="flex items-center gap-1.5 flex-wrap">
              Choose <Plus size={16} className="text-brimi-navy inline" /> <strong>&ldquo;Add to Home Screen&rdquo;</strong>.
            </span>
          </li>
          <li className="flex items-start gap-3">
            <span className="w-6 h-6 grid place-items-center rounded-full bg-brimi-navy text-white text-xs font-bold flex-shrink-0 mt-0.5">
              3
            </span>
            <span>Tap <strong>Add</strong> — BrimiH&amp;G will appear on your Home Screen.</span>
          </li>
        </ol>
        <button
          onClick={dismissIOSGuide}
          className="brimi-btn-primary w-full mt-6"
          data-testid="ios-modal-got-it"
        >
          Got it
        </button>
      </div>
    </div>
  );
}
